export default function About({ settings }) {
  const image =
    "https://customer-assets-v7afamib.emergentagent.net/job_emilios-pizza/artifacts/l6sp0kd9_215626.jpg";

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[var(--dough-warm)]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
        <div className="order-2 md:order-1">
          <img
            src="/logo-emilios.jpg"
            alt="Emilio's Restaurant & Pizzeria"
            className="h-16 w-auto mb-6 rounded-md"
          />
          <span className="section-rule" />
          <h2 className="font-serif text-4xl sm:text-5xl text-[var(--charcoal)] font-semibold leading-[1.05]">
            {settings?.business_name || "Emilio's Pizza & Restaurant"}
          </h2>
          <p className="mt-6 text-[var(--charcoal)] text-lg leading-relaxed">
            {settings?.about ||
              `Family-owned and rooted in Jackson Township, Emilio's Pizza & Restaurant has been hand-tossing pizzas and simmering Italian classics for our community for years. From our homemade dough and marinara to our carefully-sourced mozzarella, every dish is made the old-fashioned way — because good food is worth doing right.`}
          </p>
          <div className="mt-8 grid grid-cols-3 gap-6 max-w-md">
            <Stat number="24+" label="Years serving" />
            <Stat number="100%" label="Homemade dough" />
            <Stat number="4.7★" label="Customer rating" />
          </div>
        </div>
        <div className="order-1 md:order-2">
          <div className="relative">
            <img
              src={image}
              alt="Cozy Italian restaurant interior"
              className="w-full h-[440px] md:h-[560px] object-cover rounded-2xl"
              loading="lazy"
            />
            <div className="absolute -bottom-6 -left-6 hidden md:block bg-[var(--terracotta)] text-white px-6 py-4 rounded-xl shadow-lg">
              <div className="font-serif italic text-xl">Made with love</div>
              <div className="text-xs tracking-[0.2em] uppercase opacity-80">
                Since 2001
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="font-serif text-3xl font-semibold text-[var(--terracotta)]">
        {number}
      </div>
      <div className="text-xs uppercase tracking-wider text-[var(--charcoal-soft)] mt-1">
        {label}
      </div>
    </div>
  );
}
